import { useAnalytics } from "@commons-monorepo/index";
import { useAppSearchParams } from "@commons-monorepo/index";
import { BUTTON_SCROLL_TOP_EVENTS } from "./button-scroll-to-top.events";
import { useCart } from "~/modules/cart/providers/cart.provider";
import { useOutletContext } from "@remix-run/react";

const useOnClickToTopLogic = () => {
  const { storeMetadata } = useOutletContext<any>();
  const [logEvent] = useAnalytics({ storeMetadata });
  const { cartProducts } = useCart();
  const [searchParams] = useAppSearchParams();
  const tokenPersonalization = searchParams.get("token");
  const alignButtonStyles =
    tokenPersonalization || cartProducts.length >= 1
      ? { bottom: "90px", right: "7px" }
      : {};

  const handlerBackToTop = () => {
    logEvent(BUTTON_SCROLL_TOP_EVENTS.SELCET_WEB_TOP_EVENTS);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return { handlerBackToTop, alignButtonStyles };
};

export default useOnClickToTopLogic;
